import React from 'react';
import './ClientCard.css';

const ClientCard = ({ clients }) => {
  return (
    <div className="client-grid">
      {clients.map((client, index) => (
        <div key={`client-${index}`} className="client-item">
          <div className="client-logo-container">
            <img 
              src={client.imageUrl} 
              alt={client.name} 
              className="client-logo" 
              loading="lazy"
              onError={(e) => {
                e.target.onerror = null; 
                e.target.src = '/fallback-logo.png';
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ClientCard;